export const email_support = 'support@unlimitedtherapeutics.com';
export const version = '2023.10.20';
export const game_unavailable_text = 'This game is currently unavailable.';

export const filename_session_checklist= 'Daily Session Checklist and Guide_V1.pdf';
export const filename_checkin_before = 'UNLTD_Check In with Learner Before VR.pdf';
export const filename_checkin_after= 'UNLTD_Check In with Learner After VR.pdf';
